(() => {
	angular
		.module('main')
		.factory('workflowDragNDropService', workflowDragNDropService);

	workflowDragNDropService.$inject = ['workflowDataService'];

	function workflowDragNDropService(workflowDataService) {
		function replaceFirstWithSecond(list) {
			const [first, second, ...rest] = list;
			return [second, first, ...rest];
		}

		function replaceLastWithPrevious(list) {
			const modifiedList = list;
			const last = modifiedList.pop();
			modifiedList.splice(modifiedList.length - 1, 0, last);
			return modifiedList;
		}

		function isDefaultTaskInPlace(list, isLastSection = false) {
			let checkedTask;
			const firstTask = list[0];
			const lastTask = list[list.length - 1];

			checkedTask = isLastSection ? lastTask : firstTask;

			const eventType = checkedTask.eventType || checkedTask.calendarEventType;
			if (checkedTask.defaultTask && eventType !== 'MAIN_SHOOT') {
				return true;
			}
			return false;
		}

		function checkForChangeType(item, taskTypes) {
			const numberOfTasksOfEachType = taskTypes.map(item => item.length);
			const [leadNum, productionNum] = numberOfTasksOfEachType;

			const firstNumInLastSection = leadNum + productionNum;
			if (item.number >= firstNumInLastSection) {
				return 'POST_PRODUCTION';
			} else if (item.number >= leadNum) {
				return 'PRODUCTION';
			}
			return 'LEAD';
		}

		function renewTaskList(taskTypesList) {
			const taskTypes = angular.copy(taskTypesList);
			let num = 0;
			taskTypes.forEach(taskType => {
				taskType.forEach(task => {
					task.number = num;
					task.type = checkForChangeType(task, taskTypes);

					if (task.dateSequence === 'after previous task') {
						if (num != 0) {
							task.previousTask = num - 1;
						}
					} else if (task.previousTask || task.previousTask === 0) {
						delete task.previousTask;
					}
					num++;
				});
			});

			return taskTypes;
		}

		function keepDefaultTasksInPlace(taskTypesArr) {
			const taskTypes = angular.copy(taskTypesArr);
			const numberOfTaskTypes = taskTypes.length;

			taskTypes.forEach((type, index, typesArr) => {
				const lastElement = index === numberOfTaskTypes - 1;

				if (lastElement) {
					const isOrderCorrect = isDefaultTaskInPlace(type, true);
					if (!isOrderCorrect) {
						typesArr[index] = replaceLastWithPrevious(type);
					}
				} else {
					const isOrderCorrect = isDefaultTaskInPlace(type);
					if (!isOrderCorrect) {
						typesArr[index] = replaceFirstWithSecond(type);
					}
				}
			});

			return taskTypes;
		}

		function getTaskById(task2Search, taskTypes) {
			const task = angular.copy(task2Search);
			const isTaskId = task.id !== null && task.id !== undefined;

			const identificator = isTaskId ? 'id' : 'tmpId';

			if (!task[identificator]) {
				return false;
			}

			for (let i = 0, max = taskTypes.length; i < max; i++) {
				const taskType = taskTypes[i];
				const foundTask = taskType.find(
					taskInList => task[identificator] === taskInList[identificator]
				);

				if (foundTask) {
					return foundTask;
				}
			}
		}

		function checkForEqualNumbers(taskTypes) {
			const tasksArray = [].concat.apply([], taskTypes);
			const uniqueNumbers = [...new Set(tasksArray.map(a => a.number))];
			const isAllNumbersUnique = uniqueNumbers.length === tasksArray.length;
			return !isAllNumbersUnique;
		}

		function prepareTask2Save(draggedTask, taskTypes) {
			const newTaskInfo = getTaskById(draggedTask, taskTypes); // position in array with new numbers&types

			if (!newTaskInfo) {
				return false;
			}

			const isMainShootInWrongPlace =
				newTaskInfo.calendarEventType === 'MAIN_SHOOT' &&
				newTaskInfo.type !== 'PRODUCTION';

			if (isMainShootInWrongPlace) {
				return false;
			}

			if (newTaskInfo.overdueDays) {
				newTaskInfo.overdueDays = parseInt(
					newTaskInfo.overdueDays.match(/\d+/)[0],
					10
				);
			}

			const { number, type, id, overdueDays } = newTaskInfo;

			return {
				number,
				type,
				id,
				overdueDays
			};
		}

		function saveNewTasksOrder(draggedTask, taskTypes) {
			let taskListCopy = angular.copy(taskTypes); // original array
			taskListCopy = renewTaskList(taskListCopy); // array with changed numbers+types

			const task2save = prepareTask2Save(draggedTask, taskListCopy);

			if (!task2save) {
				return;
			}

			const {
				number: currentNumber,
				type: currentType,
				id,
				overdueDays
			} = task2save;

			const isPositionChanged =
				draggedTask.number !== currentNumber ||
				draggedTask.type !== currentType;

			if (!isPositionChanged) {
				return false;
			}

			return workflowDataService.saveNewTasksOrder(
				id,
				currentNumber,
				currentType,
				overdueDays
			);
		}

		return {
			getTaskById,
			checkForEqualNumbers,
			keepDefaultTasksInPlace,
			saveNewTasksOrder,
			renewTaskList
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/services/workflowDragNDropService.js